import type { StoreReferralModal, StoreReferralModalState } from './types';
import { create } from 'zustand';

const initialState: StoreReferralModalState = {
  source: null,
  visible: false,
};

export const useReferralModalStore = create<StoreReferralModal>(set => ({
  ...initialState,
  open: source => set({ visible: true, source: source ?? null }),
  close: () => set({ visible: false, source: null }),
}));
